import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    align-items: center;
    background: ${theme.v2.colors.white.primary};
    display: flex;
    flex-direction: column;
    font-family: ${theme.v2.font.family.primary};
    padding: 52px 0 96px;
    text-align: center;
    width: 100%;
  `}
`;

export const InnerContainer = styled.div`
  ${({ theme }) => css`
    @media (max-width: ${theme.v2.breakpoints.md}) {
      padding: 0 20px;
    }
  `}
`;

export const Title = styled.div`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryExtraDark};
    font-size: ${theme.v2.font.sizes.md};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: 1.5;
    margin-bottom: 16px;
    text-align: center;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.sm};
    }
  `}
`;

export const Description = styled.div`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: 1.5;
    margin-bottom: 32px;
    max-width: 677px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.xxs};
    }
  `}
`;

export const WrapperButton = styled.div`
  margin-bottom: 36px;
`;

export const BackgroundDecoration = styled.div`
  ${({ theme }) => css`
    pointer-events: none;
    position: absolute;
    inset: 0;
    z-index: 0;
    display: none;
    overflow: hidden;

    @media (min-width: ${theme.v2.breakpoints.lg}) {
      display: block;
    }
  `}
`;

export const EllipsesContainer = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  width: 50vw;
`;

export const Ellipse1 = styled.div`
  position: absolute;
  right: -28.125%;
  top: -20.264900662%;
  width: 565px;
  height: 565px;
  border-radius: 100%;
  filter: blur(150px);
  background-color: rgba(213, 164, 255, 0.20);
  background: rgba(14, 165, 223, 0.60);
  z-index: 3;
`;

export const Ellipse2 = styled.div`
  position: absolute;
  right: 6.458333333%;
  top: 31.390728477%;
  width: 445px;
  height: 445px;
  border-radius: 9999px;
  filter: blur(150px);
  background-color: rgba(242, 198, 181, 0.30);
  background: rgba(29, 197, 198, 0.30);
  /* background-color: blue; */
  z-index: 1;
`;

export const Ellipse3 = styled.div`
  position: absolute;
  right: -13.055555556%;
  top: 32.450331126%;
  width: 445px;
  height: 445px;
  border-radius: 9999px;
  filter: blur(150px);
  background-color: rgba(253, 188, 190, 0.60);
  background: rgba(47, 233, 168, 0.42);
  z-index: 2;
`;

export const Ellipse4 = styled.div`
  position: absolute;
  right: -6%;
  bottom: -8%;
  width: 482px;
  height: 482px;
  border-radius: 9999px;
  /* filter: blur(500px); */
  background-color: rgba(226, 190, 254, 0.50);
  background-color: yellow;
  transform: rotate(-92deg);
`;

export const Ellipse5 = styled.div`
  position: absolute;
  right: 2%;
  top: -4%;
  width: 503px;
  height: 502px;
  border-radius: 9999px;
  /* filter: blur(400px); */
  background-color: rgba(213, 164, 255, 0.20);
  background-color: purple;
  transform: rotate(-92deg);
`;
